// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__JjmLg","tableResponsive":"ClientDetail_tableResponsive__HEUC5"};